export default  class BeneficiarioFormModel {
    constructor(
      public id:number= 0,
      public nombre: string = "",
      public rangoEdad: string = "",
      public conviveSobreviviente:boolean = true,
      public discapavitado : string="",
      public telefono : string="",
      public correo : string="",
    ) {}
  }
  